export default "__VITE_ASSET__DSCeU968__"